import ProfilePicWithDetails from 'Components/Client/Cases/CaseDetails/ProfilePicWithDetails'
import React from 'react'
import ReactModal from 'react-modal'
import { getCaseType } from 'Utils'
import { X } from 'lucide-react'
import useIsMobile from 'Hooks/useIsMobile'

// Fields folded into the ProfilePicWithDetails header (name/subtitle) instead
// of being listed again below - every caller's profData uses these exact
// label strings for that identity info.
const HEADER_LABELS = ["First name", "Last name", "Designation", "Firm Name"];

// Cosmetic label rename for display only - doesn't touch the profData
// contract callers pass in (still keyed by these same original labels).
const LABEL_DISPLAY = {
  "Law Firm URL": "Firm website",
  "URL": "Firm website",
};

function ProfesssionalDetailsPopUp({uploadNew, onClose, singleUser, profData, content=null}) {
  const isMobile = useIsMobile();
  return (
    <ReactModal
    shouldCloseOnEsc = {true}
    shouldCloseOnOverlayClick = {true}
    onRequestClose={onClose}
    isOpen = {uploadNew}
    style={{
        overlay: {
          // above the sticky case header (z-50)
          zIndex: 60,
          backgroundColor: 'rgba(20,33,61,.45)'
        },
        content: isMobile ? {
            // phones: bottom sheet
            top: 'auto', left: 0, right: 0, bottom: 0,
            width: '100%', maxWidth: '100%',
            height: 'auto', maxHeight: '90vh', overflowY: 'auto',
            padding: 0, border: 'none',
            borderRadius: '16px 16px 0 0',
            backgroundColor: '#fffdf8',
            boxShadow: '0 -12px 32px rgba(20,33,61,.3)',
        } : {
            height: 'auto',
            maxHeight: '85vh',
            overflowY: 'auto',
            width: '380px',
            maxWidth: '92vw',
            padding: 0,
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            border: '1px solid rgba(20,33,61,.12)',
            borderRadius: '14px',
        }
      }}
    >
        <button type="button" onClick={onClose} aria-label="Close" className='absolute top-3 right-3 z-10 p-1.5 rounded-full text-[rgba(20,33,61,.45)] hover:text-navy bg-ivory'>
          <X size={18}/>
        </button>
        {isMobile && <div className='mx-auto mt-3 w-9 h-1 rounded-full bg-[rgba(20,33,61,.18)]' />}
        <div className='flex flex-col items-center p-6 bg-ivory font-plexsans text-[13px]'>
            <ProfilePicWithDetails currentProf={singleUser} picSize="l"/>

            <div className='w-full border-t border-[rgba(20,33,61,.1)] my-4'></div>

            <div className='w-full flex flex-col gap-2.5'>
                {Object.entries(profData)
                  .filter(([label]) => !HEADER_LABELS.includes(label))
                  .map(([label, value], index) => {
                    const isLink = label.toLowerCase().includes("link") || label.toLowerCase().includes("url");
                    const isExperience = label === "Experience";
                    const raw = singleUser?.[value];
                    const isList = Array.isArray(raw);
                    return (
                      <div className='flex items-start justify-between gap-4' key={index}>
                          <span className='text-[rgba(20,33,61,.55)] flex-none'>
                              {LABEL_DISPLAY[label] || label}
                          </span>
                          <span className='text-navy font-medium text-right min-w-0 break-words [overflow-wrap:anywhere]'>
                          {isList ?
                          (raw.length === 0 ?
                            <span className='italic'>--All {label?.split(" ")[0]}s--</span> :
                            raw.map((val, i) => (
                              <span key={i}>
                                {value === "casePref" ? getCaseType(val) : val}
                                {i !== raw.length - 1 ? <span>,&nbsp;</span> : ""}
                              </span>
                            ))
                          ) :
                          (raw ?
                            (isLink ?
                            <a target="_blank" rel="noopener noreferrer" className="text-tan underline" href={"https://"+raw}>{raw}</a> :
                            (isExperience ? `${raw} years` : raw))
                            : '--')}
                          </span>
                      </div>
                    );
                })}
            </div>

            {content &&
            <div className={'w-full mt-5' + (isMobile ? ' sticky bottom-0 bg-ivory pt-3 pb-1' : '')}>
              {content}
            </div>
            }
        </div>
    </ReactModal>
  )
}


export default ProfesssionalDetailsPopUp
